/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable import/prefer-default-export */
/* eslint-disable indent */
import React, { ReactElement } from 'react';
import { Card, Badge, Statistic } from 'antd';
import { TinyArea } from '@ant-design/plots';
import CountUp from 'react-countup';
import iconMap from '@app/utils/iconMap';
import './SummaryCard.less';
import { Color } from '@app/themes/colors';
import { calcGradientMiddleColor } from '@app/utils/helpers';

interface SummaryCardInterface {
  title: string;
  number: number;
  numberDiff?: number;
  periodData?: Array<number>;
  color?: string;
  countUp?: any;
  postfix?: string;
  loading?: boolean;
  description?: string | ReactElement;
  plotColor?: any;
}

export const SummaryCard: React.FC<SummaryCardInterface> = ({
  title,
  number,
  numberDiff = 0,
  periodData = [],
  color = '@primary-color',
  countUp = {},
  postfix,
  loading,
  description = '',
  plotColor = Color.blue
}) => {
  return (
    <Card
      className="summaryCard"
      bordered={false}
      title={title || 'No Title'}
      extra={<a href="#">{iconMap.info}</a>}
      bodyStyle={{ padding: 0 }}
      headStyle={{ fontWeight: 'bold', borderBottom: '0 none', padding: 8 }}
      loading={loading}
    >
      <Card.Grid
        style={{
          width: '100%',
          boxShadow: 'none',
          fontSize: 20
        }}
      >
        <CountUp
          start={0}
          end={number}
          decimals={2}
          duration={2.75}
          useEasing
          useGrouping
          separator=","
          {...(countUp || {})}
        />
        {postfix || ''}
        <Badge
          count={
            <Statistic
              value={`${Math.abs(numberDiff).toFixed(2)}%`}
              precision={1}
              valueStyle={{
                color: '#fff',
                fontSize: 10,
                borderStyle: 'solid',
                borderWidth: 1,
                borderRadius: 12,
                paddingRight: 5,
                paddingLeft: 5,
                ...(numberDiff < 0 ? { background: '#3f8600' } : { background: '#cf1322' })
              }}
              suffix={numberDiff < 0 ? iconMap.caretdown : iconMap.caretup}
            />
          }
          offset={[10, -5]}
          showZero
        />
        <p className="description">{description}</p>
      </Card.Grid>
      <Card.Grid
        style={{
          width: '40%',
          boxShadow: 'none'
        }}
      >
        <TinyArea
          {...{
            data: periodData,
            height: 32,
            // autoFit: false,
            smooth: true,
            line: { color: plotColor },
            areaStyle: () => {
              return {
                fill: `l(270) 0:#ffffff 0.5:${calcGradientMiddleColor({
                  color1: '#ffffff',
                  color2: plotColor,
                  ratio: 1 / 2
                })} 1:${plotColor}`
              };
            }
          }}
        />
      </Card.Grid>
    </Card>
  );
};
